export const FETCH_COLORWISE_COST_PROGRAM_LIST_REQUEST = 'FETCH_COLORWISE_COST_PROGRAM_LIST_REQUEST';
export const FETCH_COLORWISE_COST_PROGRAM_LIST_SUCCESS = 'FETCH_COLORWISE_COST_PROGRAM_LIST_SUCCESS';
export const FETCH_COLORWISE_COST_PROGRAM_LIST_FAILURE = 'FETCH_COLORWISE_COST_PROGRAM_LIST_FAILURE';

export const FETCH_COLORWISE_COST_COLOR_LIST_REQUEST = 'FETCH_COLORWISE_COST_COLOR_LIST_REQUEST';
export const FETCH_COLORWISE_COST_COLOR_LIST_SUCCESS = 'FETCH_COLORWISE_COST_COLOR_LIST_SUCCESS';
export const FETCH_COLORWISE_COST_COLOR_LIST_FAILURE = 'FETCH_COLORWISE_COST_COLOR_LIST_FAILURE';

export const FETCH_COLOR_DETAIL_BY_PROGRAM_REQUEST = 'FETCH_COLOR_DETAIL_BY_PROGRAM_REQUEST';
export const FETCH_COLOR_DETAIL_BY_PROGRAM_SUCCESS = 'FETCH_COLOR_DETAIL_BY_PROGRAM_SUCCESS';
export const FETCH_COLOR_DETAIL_BY_PROGRAM_FAILURE = 'FETCH_COLOR_DETAIL_BY_PROGRAM_FAILURE';

export const CREATE_COLORWISE_USERFORM = 'CREATE_COLORWISE_USERFORM';

export const SET_COLOR_WISE_DETAIL_BY_PROGRAM_PRICE = 'SET_COLOR_WISE_DETAIL_BY_PROGRAM_PRICE';

export const CREATE_COLOR_WISE_PROGRAM_COST_REQUEST = 'CREATE_COLOR_WISE_PROGRAM_COST_REQUEST';
export const CREATE_COLOR_WISE_PROGRAM_COST_SUCCESS = 'CREATE_COLOR_WISE_PROGRAM_COST_SUCCESS';
export const CREATE_COLOR_WISE_PROGRAM_COST_FAILURE = 'CREATE_COLOR_WISE_PROGRAM_COST_FAILURE';

export const UPDATE_COLOR_WISE_PROGRAM_COST_REQUEST = 'UPDATE_COLOR_WISE_PROGRAM_COST_REQUEST';
export const UPDATE_COLOR_WISE_PROGRAM_COST_SUCCESS = 'UPDATE_COLOR_WISE_PROGRAM_COST_SUCCESS';
export const UPDATE_COLOR_WISE_PROGRAM_COST_FAILURE = 'UPDATE_COLOR_WISE_PROGRAM_COST_FAILURE';

export const FETCH_COLOR_WISE_PROGRAM_COST_DATA_REQUEST = 'FETCH_COLOR_WISE_PROGRAM_COST_DATA_REQUEST';
export const FETCH_COLOR_WISE_PROGRAM_COST_DATA_SUCCESS = 'FETCH_COLOR_WISE_PROGRAM_COST_DATA_SUCCESS';
export const FETCH_COLOR_WISE_PROGRAM_COST_DATA_FAILURE = 'FETCH_COLOR_WISE_PROGRAM_COST_DATA_FAILURE';

export const DELETE_COLOR_WISE_PROGRAM_COST_REQUEST = 'DELETE_COLOR_WISE_PROGRAM_COST_REQUEST';
export const DELETE_COLOR_WISE_PROGRAM_COST_SUCCESS = 'DELETE_COLOR_WISE_PROGRAM_COST_SUCCESS';
export const DELETE_COLOR_WISE_PROGRAM_COST_FAILURE = 'DELETE_COLOR_WISE_PROGRAM_COST_FAILURE';

export const FETCH_EDIT_COLOR_WISE_PROGRAM_COST_REQUEST = 'FETCH_EDIT_COLOR_WISE_PROGRAM_COST_REQUEST';
export const FETCH_EDIT_COLOR_WISE_PROGRAM_COST_SUCCESS = 'FETCH_EDIT_COLOR_WISE_PROGRAM_COST_SUCCESS';
export const FETCH_EDIT_COLOR_WISE_PROGRAM_COST_FAILURE = 'FETCH_EDIT_COLOR_WISE_PROGRAM_COST_FAILURE';


export const COLOR_WISE_USERFORM_RESET = 'COLOR_WISE_USERFORM_RESET';